import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';

import Login from './login/component/Login';
import Reset from './login/component/Reset';
import Header from './login/component/Header';
import Footer from './login/component/Footer';
import styled from '@emotion/styled';
import { TwoFaSetUp } from './login/component/TwoFaSetUp';
import { Otp } from './login/component/Otp';

const StyledImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
});

const Auth = () => {
  const theme = useTheme();
  // Use theme breakpoints for responsive styling
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Stack
      justifyContent="space-between"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        minHeight: '100vh',
        height: '100vh',
        padding: { xs: "0", lg: "32px" },
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#F5F5F5',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        borderRadius: { xs: "0", lg: "48px"},
        backgroundImage: 'url(/bg.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
      }}>
        {matches && (
          <>
            <Box sx={{
              marginLeft: { lg: '48px', xl: '72px' },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              padding: { lg: '72px 0 64px 0', xl: '100px 0 76px 0' },
              maxWidth: { lg: '60%' },
            }}>
              <Header mode={theme.palette.mode} />
              <Box
                component="p"
                sx={{
                  fontFamily: 'poppinsblack',
                  fontSize: { lg: 'clamp(36px, 4vw, 62px)', xl: 'clamp(36px, 4vw, 80px)'},
                  lineHeight: 'clamp(42px, 4.5vw, 80px)',
                  letterSpacing: '2px',
                  fontWeight: 'bold',
                  color: '#ffffff',
                  width: { lg: '80%', xl: '75%' },
                }}
              >
                ENTERPRISE IGAMING PLATFORM BUILT FOR COMPLEX SYSTEMS
              </Box>
              <Footer/>
            </Box>
          </>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'center', lg: 'flex-end' },
            justifyContent: "space-around",
            marginRight: { lg: '48px', xl: '148px', '2xl': '148px' } as any,
            height: '100%',
            maxWidth: { xs: '100%', lg: '40%' },
            width: { xs: '100%', lg: '40%' },
            padding: { sm: '20px', lg: '0' },
            boxSizing: 'border-box',
          }}
        >
          {!matches && <Header mode={theme.palette.mode} />}
          <Box
            sx={{
              zIndex: '1',
              width: { lg: '460px' },
              height: 'auto',
              bgcolor:
                theme.palette.mode === 'dark'
                  ? theme.palette.background.paper
                  : theme.palette.background.paper,
              borderRadius: '16px',
              boxShadow: { xs: 1, sm: 3 },
              padding: { xs: '16px', sm: '20px', lg: '24px' },
            }}
          >
            <Routes>
              <Route path="/" index element={<Navigate to="/login" />}></Route>
              <Route path="/login" element={<Login />}></Route>
              <Route path="/two-fa" element={<TwoFaSetUp />}></Route>
              <Route path="/otp" element={<Otp />}></Route>
              <Route path="/reset" element={<Reset />}></Route>
            </Routes>
          </Box>
          {!matches && <Footer />}
        </Box>
      </Box>
    </Stack>
  );
};

export default Auth;
